import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCode1Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.69687 5.5517C9.98977 5.84459 9.98977 6.31947 9.69687 6.61236L4.31066 11.9986L9.69687 17.3848C9.98977 17.6777 9.98977 18.1526 9.69687 18.4454C9.40398 18.7383 8.92911 18.7383 8.63621 18.4454L2.71967 12.5289C2.42678 12.236 2.42678 11.7611 2.71967 11.4682L8.63621 5.5517C8.92911 5.25881 9.40398 5.25881 9.69687 5.5517Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.8037 5.5517C15.0965 5.25881 15.5714 5.25881 15.8643 5.5517L21.7809 11.4682C22.0737 11.7611 22.0737 12.236 21.7809 12.5289L15.8643 18.4454C15.5714 18.7383 15.0965 18.7383 14.8037 18.4454C14.5108 18.1526 14.5108 17.6777 14.8037 17.3848L20.1899 11.9986L14.8037 6.61236C14.5108 6.31947 14.5108 5.84459 14.8037 5.5517Z",
		fill: "currentColor"
	})]
});
export default SvgCode1Line;
